import "./GlBank.scss";
import CircularButton, { CustomButton, CustomButtonSmallDarkBg, CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import newRequest from "../../../utils/newRequest.js";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@mui/material";
import { showToast } from "../../../toastService.js";
import { motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GridLoader } from "react-spinners";
import { SlArrowDown } from "react-icons/sl";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { FiSearch } from "react-icons/fi";
import { FaSave } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { MdAdd, MdArrowBackIos, MdClose, MdDelete, MdEdit } from "react-icons/md";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { getFirstName, logData } from "../../../utils/genericFunctions.js";



const GlBank = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const location = useLocation();
  const showBack = location.state?.showBack || "N";
  const favMenu = location.state?.favMenu || "N";
  const menuDocid = location.state?.menuDocid || undefined;
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [bankPage, setBankPage] = useState(0);
  const [banks, setBanks] = useState([]);

  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });

  // commission rates table
  const [searchTermBank, setSearchTermBank] = useState("");
  const [branchesPage, setBranchesPage] = useState(0);
  const [rowsPerPageBranches, setRowsPerPageBranches] = useState(10);
  const [bankBranches, setBankBranches] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);

  const [isBankDialogOpened, setIsBankDialogOpened] = useState(false);
  const [currentAction, setCurrentAction] = useState(null);
  const [bankCode, setBankCode] = useState(null);
  const [bankName, setBankName] = useState(null);
  const [bankAlias, setBankAlias] = useState(null);
  const [branchCode, setBranchCode] = useState(null);
  const [branchName, setBranchName] = useState(null);
  const [branchSwiftCode, setBranchSwiftCode] = useState(null);

  const bankCodeRef = useRef(null);

  const fetchBanks = async () => {
    try {
      const res = await newRequest.post("/glBank/findAll", { result_limit: 100 });
      setBanks(res.data);
    } catch (error) {
      console.error("Error fetching banks:", error);
    }
  };


  const handleBankChangePage = (event, newPage) => {
    setBankPage(newPage);
  };

  const handleBankChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setBankPage(0);
  };

  const filteredBanksData = banks?.filter(
    (item) =>
      item.bk_name?.toLowerCase().includes(searchTermBank?.toLowerCase())
  );

  const slicedBanksData = filteredBanksData?.slice(
    bankPage * rowsPerPage,
    bankPage * rowsPerPage + rowsPerPage
  );

  const handleBankChangeData = (field, value, rowId) => {
    const newData = [...banks];
    const index = newData.findIndex(val => val._id === rowId);
    if (index !== -1) {
      newData[index][field] = value;
      setBanks(newData);
    }
  };

  const handleBranchChangeData = (field, value, rowId) => {
    const newData = [...bankBranches];
    const index = newData.findIndex(val => val._id === rowId);
    if (index !== -1) {
      newData[index][field] = value;
      setBankBranches(newData);
    }
  };


  const resetBankFields = () => {
    setBankCode(null);
    setBankName(null);
    setBankAlias(null);
    setBranchCode(null);
    setBranchName(null);
    setBranchSwiftCode(null);
  }

  const handleAccodionChange = (panel, bank) => (event, isExpanded) => {
    try {
      setExpanded(isExpanded ? panel : false);
      setSelectedBank(isExpanded ? bank : null);
      setBankBranches(bank?.bk_branches);
    } catch (error) {
      console.log(error)
    }
  };



  const handleBranchesChangePage = (event, newPage) => {
    setBranchesPage(newPage);
  };

  const handleBranchesChangeRowsPerPage = (event) => {
    setRowsPerPageBranches(parseInt(event.target.value, 10));
    setBranchesPage(0);
  };


  // const filteredBranchesData = bankBranches.filter(
  //   (item) =>
  //     item.male?.toLowerCase().includes(searchTermBank?.toLowerCase())
  // );
  const filteredBranchesData = bankBranches;

  const slicedBranchesData = filteredBranchesData.slice(
    branchesPage * rowsPerPage,
    branchesPage * rowsPerPage + rowsPerPage
  );


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteBank") {
        setIsProcessing(true);
        const res = await newRequest.delete(`/glBank/del/${selectedBank._id}`);
        setIsProcessing(false);
        if (res.data?.msg === "deleted") {
          setBanks((prev) => prev.filter(val => val._id !== selectedBank._id));
          showToast(t('deleted'), "success");
        } else {
          showToast(res.data?.msg || `error deleting bank!`, "error");
        }
      } else if (confirmDialogAction === "deleteBranch") {
        setIsProcessing(true);
        const res = await newRequest.post(
          "/glBank/delBranch",
          {
            bank_docid: selectedBank._id,
            branch_code: objectToAction.object_id
          }
        );
        setIsProcessing(false);
        if (res.data?.msg === "deleted") {
          setBankBranches((prev) => prev.filter(val => val.branch_code !== objectToAction.object_id));
          showToast(t('deleted'), "success");
        } else {
          showToast(res.data?.msg || `error deleting branch!`, "error");
        }
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };



  useEffect(() => {
    setBranchesPage(0);
  }, [selectedBank]);

  useEffect(() => {
    if (isBankDialogOpened && bankCodeRef.current) {
      bankCodeRef.current.focus();
    }
  }, [isBankDialogOpened]);


  useEffect(() => {
    fetchBanks();
  }, []);


  return (
    <motion.div
      className="bank"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="navbar">
        <div className="navbar-left">
          <div className="homeSearch">
            <FiSearch className="homeSearchIcon" />
            <input
              className="homeSearchInput"
              type="text"
              placeholder={t('search')}
              value={searchTermBank}
              onChange={(e) => setSearchTermBank(e.target.value)}
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") handleSearchUsers();
            // }}
            />
            {searchTermBank?.length > 0 ? (
              <MdClose
                className="homeSearchClear"
                onClick={() => setSearchTermBank("")}
              />
            ) : (
              <span className="homeSearchClearPlaceholder" />
            )}
          </div>
        </div>
        <div className="navbar-right">
          <CustomLoadingButton
            currentTheme={currentTheme}
            borderRadiusType="both"
            variant="tint"
            color="#0ea5a4"
            tooltip={"Add bank and default branch"}
            iconPosition="end"
            endIcon={<MdAdd />}
            onClick={() => {
              setCurrentAction("addBank");
              setIsBankDialogOpened(true);
            }}
          >
            {`${t('add')} ${t('bank')}`}
          </CustomLoadingButton>
          {/* This part shows if the menu was opened from home screen */}
          {showBack === "Y" && <hr className="separator-v" />}
          {showBack === "Y" &&
            <span className="back-icon" onClick={() => navigate(-1)}>
              <MdArrowBackIos size={24} />
            </span>}
        </div>
      </div>

      {slicedBanksData?.length > 0 &&
        <div className="bank-table-content">
          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
            className="table-container">
            <Table sx={{ width: "max-content", border: 'none' }}>
              <TableBody className="tablebody-accordion">
                {slicedBanksData?.map((bank, index) => (
                  <TableRow
                    key={bank._id}
                    className="tablerow-accordion">
                    <TableCell className="table-cell-accordion"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                      <Accordion className="accordion" expanded={expanded === bank._id} onChange={handleAccodionChange(bank._id, bank)}>
                        <AccordionSummary
                          className="accordion-summary"
                          expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                          id={`panel-${bank._id}-header`}
                        >
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", marginRight: "50px" }}>
                            <Typography>
                              <h1 className="sub-title">{bankPage * rowsPerPage + index + 1}. {bank.bk_name}</h1>
                            </Typography>
                            <Typography>
                              <div className="right-side-details">
                                <>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    color="#43A047"
                                    onClick={() => {
                                      setBankCode(bank.bk_code);
                                      setBankName(bank.bk_name);
                                      setBankAlias(bank.bk_alias);
                                      setSelectedBank(bank);
                                      setCurrentAction("editBank");
                                      setIsBankDialogOpened(true);
                                    }}
                                    icon={<MdEdit />}
                                    width={"30px"}
                                    height={"30px"} />
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    color="#D32F2F"
                                    onClick={() => {
                                      try {
                                        setBankCode(bank.bk_code);
                                        setBankName(bank.bk_name);
                                        setBankAlias(bank.bk_alias);
                                        setSelectedBank(bank);
                                        setObjectToAction({
                                          object_id: bank?._id,
                                          action_text: `Delete ${bank.bk_name}?`,
                                          new_doc_status: "deleteBank",
                                        });
                                        setConfirmDialogAction("deleteBank");
                                        setIsConfirmDialogOpen(true);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    icon={<MdDelete />}
                                    width={"30px"}
                                    height={"30px"} />
                                </>
                                <div className="bank-details">
                                  <h1 className="account-no">{`${t('alias').toUpperCase()}: ${bank.bk_alias}`}</h1>
                                  <h1 className="account-no">{`${t('code').toUpperCase()}: ${bank.bk_code}`}</h1>
                                </div>
                              </div>
                            </Typography>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                          <div className="search">
                            <div className="navbar">
                              {/* <div className="navbar-left">
                                <div className="search-input-wrapper">
                                  <SearchIcon className="search-input-icon" />
                                  <input
                                    className="search-input"
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTermBank}
                                    onChange={(e) => setSearchTermBank(e.target.value)}
                                  />
                                  {searchTermBank.length > 0 && (
                                    <IoClose
                                      onClick={handleClearSearchRates}
                                      className="search-input-icon"
                                    />
                                  )}
                                </div>
                              </div> */}
                              <div className="navbar-right">
                                {/* <CustomLoadingButton startIcon={<FaSave />} onClick={saveRecord}>
                                  {savingTitle}
                                </CustomLoadingButton> */}
                              </div>
                            </div>
                          </div>
                          <div className="table-content">
                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                              <Table sx={{ width: "max-content", border: 'none' }}>
                                <TableHead className="tablehead">
                                  <TableRow className="tablerow">
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "50px", fontWeight: "bold", alignItems: "center", justifyContent: "center" }}>
                                      #
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "200px" }}>
                                      {t('code').toUpperCase()}
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ display: "flex", width: "auto" }}>
                                      <div style={{ display: "flex", width: "100%", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                                        {t('name').toUpperCase()}
                                        <CustomButtonSmallDarkBg
                                          currentTheme={currentTheme}
                                          iconPosition='end'
                                          borderRadiusType="both"
                                          variant="tint"
                                          color="#7CB342"
                                          tooltip={`Add branch to ${bank.bk_name}`}
                                          endIcon={<MdAdd />}
                                          onClick={() => {
                                            setBankCode(bank.bk_code);
                                            setBankName(bank.bk_name);
                                            setBankAlias(bank.bk_alias);
                                            setSelectedBank(bank);
                                            setCurrentAction("addBranch");
                                            setIsBankDialogOpened(true);
                                          }}
                                        >
                                          {t('addBranch')}
                                        </CustomButtonSmallDarkBg>
                                      </div>
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "100px" }}>
                                      {t('swift').toUpperCase()}
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "100px" }}>
                                      {t('action').toUpperCase()}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody className="tablebody">
                                  {slicedBranchesData?.map((row, index) => (
                                    <TableRow
                                      key={row?._id}
                                      className={`${selectedBranch?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                      onClick={() => setSelectedBranch(row)}
                                    >
                                      <TableCell className="table-cell" style={{ display: "flex", maxWidth: "50px", fontWeight: "bold", alignItems: "center", justifyContent: "center" }}>
                                        {branchesPage * rowsPerPage + index + 1}
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ display: "flex", maxWidth: "200px" }}>
                                        <span className="param_type">{row?.branch_code}</span>
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ display: "flex", width: "auto" }}>
                                        <span className="param_type">{row?.branch_name}</span>
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ alignItems: "center", maxWidth: "100px", flexDirection: "row", gap: "5px" }}>
                                        <span className="param_type">{row?.branch_swift_code}</span>
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ alignItems: "center", maxWidth: "100px", flexDirection: "row", gap: "5px" }}>
                                        <CircularButton
                                          currentTheme={currentTheme}
                                          color="#43A047"
                                          onClick={() => {
                                            setBranchCode(row?.branch_code);
                                            setBranchName(row?.branch_name);
                                            setBranchSwiftCode(row?.branch_swift_code);
                                            setSelectedBank(bank);
                                            setSelectedBranch(row);
                                            setCurrentAction("editBranch");
                                            setIsBankDialogOpened(true);
                                          }}
                                          icon={<MdEdit />}
                                          width={"30px"}
                                          height={"30px"} />
                                        <CircularButton
                                          currentTheme={currentTheme}
                                          color="#D32F2F"
                                          onClick={() => {
                                            try {
                                              setObjectToAction({
                                                object_id: row?.branch_code,
                                                action_text: `Delete ${row?.branch_name}?`,
                                                new_doc_status: "deleteBranch",
                                              });
                                              setConfirmDialogAction("deleteBranch");
                                              setIsConfirmDialogOpen(true);
                                            } catch (error) {
                                              console.log(error);
                                            }
                                          }}
                                          icon={<MdDelete />}
                                          width={"30px"}
                                          height={"30px"} />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                              {bankBranches.length > rowsPerPageBranches &&
                                <TablePagination
                                  rowsPerPageOptions={[10]}
                                  rowsPerPage={rowsPerPageBranches}
                                  onRowsPerPageChange={handleBranchesChangeRowsPerPage}
                                  component="div"
                                  count={bankBranches.length}
                                  page={branchesPage}
                                  onPageChange={handleBranchesChangePage}
                                />}
                            </TableContainer>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10]}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleBankChangeRowsPerPage}
              component="div"
              count={filteredBanksData.length}
              page={bankPage}
              onPageChange={handleBankChangePage}
            />
          </TableContainer>
        </div>
      }
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {isBankDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">
                {(() => {
                  if (currentAction === "addBank") {
                    return t('addBank');
                  } else if (currentAction === "editBank") {
                    return t('editBank');
                  } else if (currentAction === "addBranch") {
                    return t('addBranch');
                  } else if (currentAction === "editBranch") {
                    return t('editBranch');
                  }
                })()}
              </h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    resetBankFields();
                    setIsBankDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="form-grid-auto">
                {["addBank", "addBranch"].includes(currentAction) &&
                  <div className="input-item-with-label top" >
                    <label htmlFor="bankCode"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}>
                      {t('code').toUpperCase()}
                    </label>
                    <input
                      ref={bankCodeRef}
                      id="bankCode"
                      name="bankCode"
                      type="text"
                      placeholder={t('code').toUpperCase()}
                      value={bankCode}
                      className="form-input-item"
                      style={{ width: "200px", height: "max-content" }}
                      onChange={(e) => setBankCode(e.target.value)}
                      disabled={!["addBank"].includes(currentAction)}
                    />
                  </div>}
                {["addBank", "editBank", "addBranch"].includes(currentAction) &&
                  <div className="input-item-with-label top" >
                    <label htmlFor="bankName" className="form-dropdown-label">
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      id="bankName"
                      name="bankName"
                      type="text"
                      placeholder={t('name').toUpperCase()}
                      value={bankName}
                      className="form-input-item"
                      style={{ width: "300px", height: "max-content" }}
                      onChange={(e) => setBankName(e.target.value)}
                      onBlur={(e) => {
                        if (e.target.value && !bankAlias) {
                          setBankAlias(getFirstName(e.target.value));
                        }
                      }}
                      disabled={!["addBank", "editBank"].includes(currentAction)}
                    />
                  </div>}
                {["addBank", "editBank"].includes(currentAction) &&
                  <div className="input-item-with-label top" >
                    <label htmlFor="bankAlias" className="form-dropdown-label">
                      {t('alias').toUpperCase()}
                    </label>
                    <input
                      id="bankAlias"
                      name="bankAlias"
                      type="text"
                      placeholder={t('alias').toUpperCase()}
                      value={bankAlias}
                      className="form-input-item"
                      style={{ width: "200px", height: "max-content" }}
                      onChange={(e) => setBankAlias(e.target.value)}
                    />
                  </div>}
              </div>
              {["addBank", "addBranch"].includes(currentAction) && <hr className="separator-h" />}
              {["addBank"].includes(currentAction) && <span className="normal-title">{t('defaultBranch').toUpperCase()}</span>}
              <div className="form-grid-auto">
                {["addBank", "addBranch"].includes(currentAction) &&
                  <div className="input-item-with-label top" >
                    <label htmlFor="branchCode" className="form-dropdown-label" style={{ width: "100px" }}>
                      {t('code').toUpperCase()}
                    </label>
                    <input
                      id="branchCode"
                      name="branchCode"
                      type="text"
                      placeholder={t('code').toUpperCase()}
                      value={branchCode}
                      className="form-input-item"
                      style={{ width: "200px", height: "max-content" }}
                      onChange={(e) => setBranchCode(e.target.value)}
                    />
                  </div>}
                {["addBank", "addBranch", "editBranch"].includes(currentAction) &&
                  <div className="input-item-with-label top" >
                    <label htmlFor="branchName"
                      className="form-dropdown-label"
                    >
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      id="branchName"
                      name="branchName"
                      type="text"
                      placeholder={t('name').toUpperCase()}
                      value={branchName}
                      className="form-input-item"
                      style={{ width: "300px", height: "max-content" }}
                      onChange={(e) => setBranchName(e.target.value)}
                    />
                  </div>}
                {["addBank", "addBranch", "editBranch"].includes(currentAction) &&
                  <div className="input-item-with-label top" >
                    <label htmlFor="branchSwiftCode" className="form-dropdown-label" style={{ width: "100px" }}>
                      {t('swift').toUpperCase()}
                    </label>
                    <input
                      id="branchSwiftCode"
                      name="branchSwiftCode"
                      type="text"
                      placeholder={t('swift').toUpperCase()}
                      value={branchSwiftCode}
                      className="form-input-item"
                      style={{ width: "200px", height: "max-content" }}
                      onChange={(e) => setBranchSwiftCode(e.target.value)}
                    />
                  </div>}
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#1976D2"
                endIcon={<IoCheckmarkDoneSharp />}
                onClick={async () => {
                  try {

                    if (["addBank", "editBank"].includes(currentAction)) {
                      if (!bankCode) {
                        setNotifyDialogTitle(t('note'));
                        setNotifyDialogText(t('mandatoryParam2', { param1: t('bank'), param2: t('code') }));
                        setIsNotifyDialogOpen(true);
                        return;
                      }

                      if (!bankName) {
                        setNotifyDialogTitle(t('note'));
                        setNotifyDialogText(t('mandatoryParam2', { param1: t('bank'), param2: t('name') }));
                        setIsNotifyDialogOpen(true);
                        return;
                      }
                    }

                    if (["addBank", "addBranch", "editBranch"].includes(currentAction)) {
                      if (!branchCode) {
                        setNotifyDialogTitle(t('note'));
                        setNotifyDialogText(t('mandatoryParam2', { param1: t('branch'), param2: t('code') }));
                        setIsNotifyDialogOpen(true);
                        return;
                      }

                      if (!branchName) {
                        setNotifyDialogTitle(t('note'));
                        setNotifyDialogText(t('mandatoryParam2', { param1: t('branch'), param2: t('name') }));
                        setIsNotifyDialogOpen(true);
                        return;
                      }
                    }

                    if (currentAction === "addBank") {
                      const res = await newRequest.post(
                        "/glBank/add",
                        {
                          bk_code: bankCode,
                          bk_name: bankName,
                          bk_alias: bankAlias,
                          bk_status: "Active",
                          bk_branches: [
                            {
                              branch_code: branchCode,
                              branch_name: branchName,
                              branch_swift_code: branchSwiftCode,
                              branch_enabled: "Y"
                            }
                          ]
                        }
                      );

                      if (res.data.msg === "exists") {
                        showToast(`Bank with CODE ${bankCode} already exists`, "error");
                      } else {
                        resetBankFields();
                        setBanks((prevData) => [...prevData, res.data?.doc]);
                        setIsBankDialogOpened(false);
                        showToast(`Bank ${bankName} added`, "success");
                      }
                    } else if (currentAction === "editBank") {
                      await newRequest.put(
                        `/glBank/upd/${selectedBank?._id}`,
                        {
                          bk_name: bankName,
                          bk_alias: bankAlias
                        }
                      );
                      handleBankChangeData("bk_name", bankName, selectedBank?._id);
                      handleBankChangeData("bk_alias", bankAlias, selectedBank?._id);
                      setIsBankDialogOpened(false);
                      showToast(t('updated'), "success");
                    } else if (currentAction === "addBranch") {
                      // logData("selectedBank", selectedBank);
                      const res = await newRequest.post(
                        "/glBank/addBranch",
                        {
                          bank_docid: selectedBank._id,
                          branch_code: branchCode,
                          branch_name: branchName,
                          branch_swift_code: branchSwiftCode,
                          branch_enabled: "Y"
                        }
                      );
                      // logData("add branch", res.data);
                      if (res.data.msg === "exists") {
                        showToast(`Branch with CODE ${branchCode} already exists under ${selectedBank?.bk_name}`, "error");
                      } else {
                        resetBankFields();
                        setBankBranches((prevData) => [...prevData, res.data?.doc]);
                        setIsBankDialogOpened(false);
                        showToast(`Branch ${branchCode} added`, "success");
                      }
                    } else if (currentAction === "editBranch") {
                      await newRequest.post("/glBank/updBranch/",
                        {
                          bank_docid: selectedBank._id,
                          branch_code: branchCode,
                          branch_name: branchName,
                          branch_swift_code: branchSwiftCode,
                        }
                      );
                      handleBranchChangeData("branch_name", branchName, selectedBranch?._id);
                      handleBranchChangeData("branch_swift_code", branchSwiftCode, selectedBranch?._id);
                      setIsBankDialogOpened(false);
                      showToast(t('updated'), "success");
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }}>
                {(() => {
                  if (currentAction === "addBank") {
                    return t('addBank');
                  } else if (currentAction === "editBank") {
                    return t('editBank');
                  } else if (currentAction === "addBranch") {
                    return t('addBranch');
                  } else if (currentAction === "editBranch") {
                    return t('editBranch');
                  }
                })()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t("confirmation")}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader
              color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )
      }
    </motion.div>
  );
};

export default GlBank;
